import mod from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/modal/modal.vue?vue&type=script&lang=js
// module id = 4jkZ
// module chunks = 37